import React from 'react';
import {Progress} from 'antd';

export const LCProgress = props => <Progress {...props} />;
